import { Dashboard } from "./DashboardPage";

export const CheckOutsAnalyticsPage = () => {
  return (
    <Dashboard header="Check out Analytics">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
          flexDirection: "column",
        }}
      >
        <h2>Coming Soon!</h2>
      </div>
    </Dashboard>
  );
};
